import { $, $$ } from '../helpers/selectors';

const SELECTOR = '.module-icon-grid--article';

class IconModule {
  constructor() {
    if (! $(SELECTOR)) {
      return false;
    }

	$$(SELECTOR).forEach(section => {
      let titleMinHeight = 0;
      $$('.module-icon-grid__item', section).forEach(item => {
        const titles = $$('.module-icon-grid__content-heading-container', item);
        titles.forEach(title => {
          title.style.removeProperty('min-height');
          if (title.offsetHeight > titleMinHeight) {
            titleMinHeight = title.offsetHeight;
          }
        });
      });
	  $$('.module-icon-grid__item', section).forEach(item => {
        const titles = $$('.module-icon-grid__content-heading-container', item);
        titles.forEach(title => {
          title.style.minHeight = titleMinHeight + 'px';
        });
      });
    });
  }
}

export default IconModule;

jQuery(document).ready(function() {
  if (jQuery('.module-icon-grid.collapse-text').length) {
    var text_font_size = jQuery('.module-icon-grid__texts').css('font-size').replace("px", "");
    var text_line_height = jQuery('.module-icon-grid__texts').css('line-height').replace("px", "");
    var line_height_difference = text_line_height - text_font_size;
    var text_box_height = (text_font_size * 2) + (line_height_difference * 2);

    jQuery('.module-icon-grid.collapse-text').find('.module-icon-grid__texts').css('height', text_box_height + 'px');
    jQuery('.module-icon-grid.collapse-text .module-icon-grid__texts-inner').each(function() {
      if(jQuery(this).height() > text_box_height) {
        jQuery(this).parents('.module-icon-grid__contents-inner').append('<button class="see-more">Show More</button>');
      }
    });
    jQuery(document).on('click', 'button.see-more', function() {
      jQuery(this).siblings('.module-icon-grid__texts').css('height', 'auto');
      jQuery(this).html('Show Less').toggleClass('see-less').toggleClass('see-more');
    });
    jQuery(document).on('click', 'button.see-less', function() {
      jQuery(this).siblings('.module-icon-grid__texts').css('height', text_box_height + 'px');
      jQuery(this).html('Show More').toggleClass('see-less').toggleClass('see-more');
    });
  }
});

jQuery(window).resize(function() {
  if (jQuery('.module-icon-grid.collapse-text').length) {
    setTimeout(function() {
      var text_font_size = jQuery('.module-icon-grid__texts').css('font-size').replace("px", "");
      var text_line_height = jQuery('.module-icon-grid__texts').css('line-height').replace("px", "");
      var line_height_difference = text_line_height - text_font_size;
      var text_box_height = (text_font_size * 2) + (line_height_difference * 2);
    }, 2000);
  }
});
